
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    aiObjects: {
        showMode: "none",
        showOverlay: false,
        aiDetectObj: {},
        aiTesseract: {}
    },
}

const AiReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.AI_UPDATE_AIOBJECTS:
            return { loading: false, aiObjects: { ...state.aiObjects, ...action.payload } }
        case actionTypes.AI_SET_LOADING:
            return { ...state, loading: action.payload }
        default:
            return state;
    }
}

export default AiReducer;